import {
  setCurrent,
  setCurrentId,
  setDTime,
  setEdit,
  setEditContext,
  setEditOrder,
  setPaymentCard,
  setPaymentMethod,
  setPickUpIssueFix,
  setPTime,
  setSelectedAddress,
} from "../../../store/Actions/authActions";
import {
  cartApi,
  cartEdit,
  fetchCartItem,
  selectAddress,
  setTime,
  setTimePickup,
} from "../../../store/Actions/cartActions";
import { editContextFromOrder, slotDay } from "../../../utils/editOrder";

/**
 * Ouvre une commande dans le récapitulatif en mode édition (design
 * « Modifier la commande », Checkout/Recap/EditRecap), comme useEditOrder
 * sur mobile :
 *  - adresse, créneaux et paiement de la commande remis dans le checkout ;
 *  - panier vidé puis rempli avec les lignes de la commande ;
 *  - contexte d'édition (lignes d'origine, verrous, problème à résoudre).
 *
 * `issue` : "pickup" | "delivery" pour « Reprogrammer », null sinon.
 * Renvoie la route du récapitulatif.
 */
/** Boîte d'erreur quand la commande n'a pas pu être rouverte. */
export const editFailed = (t) => ({
  icon: "alert-circle",
  tone: "danger",
  title: t("Edit order", { ns: "translation" }),
  message: t("We couldn't open this order for editing. Try again in a moment.", { ns: "translation" }),
});

export const startOrderEdit = (order, issue = null) => async (dispatch, getState) => {
  const context = editContextFromOrder(order, issue);

  const type = order.collection_point_id ? "office" : "home";
  const addressId = type === "office" ? order.collection_point_id : order.delivery_address_id;
  dispatch(setSelectedAddress(`${addressId}`, type));
  dispatch(selectAddress(type));

  dispatch(setTimePickup(slotDay(context.pickup.key)));
  dispatch(setPTime(context.pickup.slot));
  dispatch(setTime(slotDay(context.delivery.key)));
  dispatch(setDTime(context.delivery.slot));

  // Drapeaux de l'ancien parcours, encore lus par le catalogue et l'ancienne page.
  dispatch(setCurrentId(order.id));
  dispatch(setCurrent(order.products));
  dispatch(setEditOrder(true));
  dispatch(setEdit(false));
  dispatch(setPickUpIssueFix(context.issue === "pickup"));
  dispatch(setPaymentCard(order.payment_method_id ? order.payment_method_id : null));
  dispatch(setPaymentMethod(order.payment_method_id ? "Debit Card" : "Wallet"));
  dispatch(setEditContext(context));

  // Même synchronisation du panier que l'ancienne page : on le vide, puis on
  // y remet les lignes de la commande.
  await dispatch(fetchCartItem());
  const items = getState()?.cart?.cartItems || [];
  await Promise.all(items.map((item) => dispatch(cartApi(item, "destroyAllProducts"))));
  await dispatch(cartEdit(order));
  await dispatch(fetchCartItem());

  // cartEdit avale ses erreurs : un panier resté vide veut dire que la
  // recopie a échoué. On sort du mode édition plutôt que d'ouvrir un
  // checkout vide au bouton grisé.
  if ((order.products || []).length && !(getState()?.cart?.cartItems || []).length) {
    await leaveOrderEdit()(dispatch, getState);
    throw new Error("order-edit-cart-empty");
  }

  return "/checkout";
};

/**
 * Sort du mode édition, après mise à jour, abandon ou suppression : panier
 * vidé (serveur compris, comme l'ancien bouton « × ») et état d'édition
 * effacé. L'adresse choisie reste : une nouvelle commande repart d'elle.
 */
export const leaveOrderEdit = () => async (dispatch, getState) => {
  const items = getState()?.cart?.cartItems || [];
  await Promise.all(items.map((item) => dispatch(cartApi(item, "destroyAllProducts"))));

  dispatch(setEditContext(null));
  dispatch(setEditOrder(false));
  dispatch(setEdit(false));
  dispatch(setPickUpIssueFix(false));
  dispatch(setCurrentId(null));
  dispatch(setCurrent(null));
  dispatch(setTimePickup(null));
  dispatch(setPTime(null));
  dispatch(setTime(null));
  dispatch(setDTime(null));
};
